// Nachweise der Dienstleister (Handoff Dienstleister §9): Status gültig / läuft ab (< 60 Tage) / abgelaufen.

export type NachweisArt = 'freistellung_48b' | 'haftpflicht' | 'gewerbe' | 'mindestlohn';
export type NachweisStatus = 'gueltig' | 'laeuft_ab' | 'abgelaufen';

export const NACHWEIS_LABEL: Record<NachweisArt, string> = {
  freistellung_48b: 'Freistellungsbescheinigung § 48b EStG',
  haftpflicht: 'Betriebshaftpflicht',
  gewerbe: 'Gewerbeanmeldung / Handwerksrolle',
  mindestlohn: 'Mindestlohn- & Nachunternehmererklärung',
};

/** Vorwarnzeit „läuft ab“. */
export const NACHWEIS_WARNTAGE = 60;

/** ISO-Datum plus n Tage (UTC, ohne Zeitzonen-Sprung). */
export function plusTage(iso: string, tage: number): string {
  const d = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + tage);
  return d.toISOString().slice(0, 10);
}

/** Ohne Ablaufdatum (unbefristet) immer gültig. */
export function nachweisStatus(gueltigBis: string | null, heute: string): NachweisStatus {
  if (!gueltigBis) return 'gueltig';
  const bis = gueltigBis.slice(0, 10);
  if (bis < heute) return 'abgelaufen';
  if (bis < plusTage(heute, NACHWEIS_WARNTAGE)) return 'laeuft_ab';
  return 'gueltig';
}

export interface NachweisRoh { dienstleister_id: string; art: string; gueltig_bis: string | null }

/** Je Art der aktuellste Nachweis (spätestes Ablaufdatum; unbefristet schlägt befristet). */
export function aktuelleNachweise<T extends NachweisRoh>(rows: readonly T[]): T[] {
  const je = new Map<string, T>();
  for (const r of rows) {
    const alt = je.get(r.art);
    if (!alt || (alt.gueltig_bis !== null && (r.gueltig_bis === null || r.gueltig_bis > alt.gueltig_bis))) je.set(r.art, r);
  }
  return [...je.values()];
}
